import axios from "axios";
import { DEFAULT_URL } from "../config";

export async function post(url, body, token) {
    const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
    };

    if (token) {
        headers["Sv-Authorization"] = token;
    }

    return await axios
        .post(`${DEFAULT_URL}/${url}`, body, {
            headers,
        })
        .then((r) => r.data)
        .catch((e) => {
            console.log(e);
            return {
                status: "error",
                message: e.message,
            };
        });
}

export async function get(url, token) {
    const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
    };

    if (token) {
        headers["Sv-Authorization"] = token;
    }

    return await axios
        .get(`${DEFAULT_URL}/${url}`, {
            headers,
        })
        .then((r) => {
            return r.data;
        })
        .catch((e) => {
            console.log(e);
            return {
                status: "error",
                message: e.message,
            };
        });
}
